module.exports = __webpack_public_path__ + "static/media/Logo_STATION_F.0bd00e9e.svg";